import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCaseLocationList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'CaseLocation/GetAllCaseLocationList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCaseLocation = async (CaseLocationDet) => {
    //debugger;
    //console.log(JSON.stringify(CaseLocationDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `CaseLocation/CreateNewCaseLocation`, 
        JSON.stringify(CaseLocationDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCaseLocation = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CaseLocation/ActivateDeActivateCaseLocation?LocationId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCaseLocation = async(CaseLocationDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CaseLocation/UpdateCaseLocation', 
        JSON.stringify(CaseLocationDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}